function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import cn from 'classnames';
import { motion } from 'framer-motion';
import { formatTimestamp } from 'helpers/datetime';
import Button from 'components/Form/Button';
import intlShape from 'shapes/intlShape';
import Dropdown from 'svg/ap/arrow.svg';
import messages from '../messages';
import styles from './VisitNotes.pcss';
var _React_PureComponent;
class VisitNoteHeader extends (_React_PureComponent = React.PureComponent) {
    renderNoteHeaderDateRange(payload) {
        const { start, end } = payload;
        if (!start && !end) {
            return null;
        }
        const startDate = formatTimestamp(start) || '';
        const endDate = formatTimestamp(end) || '';
        let dateRange = '';
        if (startDate) dateRange += startDate;
        if (startDate && endDate) dateRange += ' - ';
        if (endDate) dateRange += endDate;
        return /*#__PURE__*/ _jsx("span", {
            className: styles.note__header__dateRange,
            children: dateRange
        });
    }
    renderNoteValue(payload) {
        const { value, standardDeviation, unitSymbol } = payload;
        const hasValue = value !== null && value !== undefined;
        const hasUnitSymbol = unitSymbol !== null && unitSymbol !== undefined;
        if (!hasValue && !hasUnitSymbol) {
            return null;
        }
        let noteValue = hasValue ? `${value}` : 'N/A';
        const hasStdDev = standardDeviation !== null && standardDeviation !== undefined;
        if (hasStdDev) noteValue += `\u00b1${standardDeviation}`;
        if (unitSymbol && hasValue) noteValue += unitSymbol;
        return /*#__PURE__*/ _jsx("span", {
            dir: "ltr",
            children: noteValue
        });
    }
    render() {
        const { payload } = this.props.note;
        if (!payload) {
            return null;
        }
        const { titleMessage, rangeValue, value, unitSymbol, status } = payload;
        const hasValue = value !== null && value !== undefined;
        const hasUnitSymbol = unitSymbol !== null && unitSymbol !== undefined;
        const hasRangeValue = rangeValue !== null && rangeValue !== undefined;
        let noteHeader = titleMessage ? this.props.intl.formatMessage(titleMessage) : '';
        if (hasRangeValue) noteHeader += ` (${rangeValue})`;
        if (hasValue || hasUnitSymbol) noteHeader += ': ';
        const isOpen = !this.props.openVisitNotes || this.props.openVisitNotes.indexOf(this.props.note.noteId) !== -1;
        return /*#__PURE__*/ _jsxs("div", {
            className: "d-flex justify-content-between",
            children: [
                /*#__PURE__*/ _jsxs("h3", {
                    className: cn(styles.note__header, {
                        [styles[`note__header--${status}`]]: status
                    }),
                    children: [
                        noteHeader,
                        this.renderNoteValue(payload),
                        this.renderNoteHeaderDateRange(payload)
                    ]
                }),
                !!this.props.onChangeNotesVisibility && /*#__PURE__*/ _jsxs(Button, {
                    styleModifier: "transparent",
                    className: styles.note__header__toggler,
                    onClick: ()=>this.props.onChangeNotesVisibility(this.props.note.noteId),
                    children: [
                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.buttons[isOpen ? 'hideNotes' : 'showNotes'])),
                        /*#__PURE__*/ _jsx(motion.div, {
                            className: `${styles.note__header__togglerCaret} ml-3`,
                            initial: {
                                rotate: '0deg'
                            },
                            animate: isOpen ? 'open' : 'close',
                            variants: {
                                open: {
                                    rotate: '180deg'
                                },
                                close: {
                                    rotate: '0deg'
                                }
                            },
                            children: /*#__PURE__*/ _jsx(Dropdown, {})
                        })
                    ]
                })
            ]
        });
    }
}
_define_property(VisitNoteHeader, "propTypes", {
    // Explicit props
    note: PropTypes.shape({
        noteId: PropTypes.string,
        payload: PropTypes.object
    }).isRequired,
    openVisitNotes: PropTypes.arrayOf(PropTypes.string),
    onChangeNotesVisibility: PropTypes.func,
    // Implicit props
    intl: intlShape
});
export default injectIntl(VisitNoteHeader);
